import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BlockContent from '@sanity/block-content-to-react';
import { LinkSerializer } from './LinkSerializer';
import './PortableText.global.scss';

const PortableText = ({ content, className }) => {
  const serializers = {
    marks: {
      link: LinkSerializer,
    },
  };

  return (
    <BlockContent
      renderContainerOnSingleChild
      className={classnames('portable-text', className)}
      blocks={content}
      serializers={serializers}
    />
  );
};

PortableText.propTypes = {
  content: PropTypes.array.isRequired,
  className: PropTypes.string,
};

PortableText.defaultProps = {
  className: null
};

export { PortableText };
